export default "__VITE_ASSET__DSso$LdY__"